import { BarChart } from 'bricks-ui/packages/bricks-ui';
export default BarChart;
